import { Link, useNavigate } from 'react-router'
import { ArrowLeft, LayoutDashboard, ShieldOff } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function ForbiddenPage() {
  const navigate = useNavigate()

  return (
    <div className="grid min-h-dvh place-items-center bg-[var(--color-page)] p-6">
      <div className="hrms-card w-full max-w-md px-8 py-10 text-center">
        <span className="mx-auto grid size-16 place-items-center rounded-2xl bg-[var(--color-tint-red)] ring-8 ring-[var(--color-tint-red)]/40">
          <ShieldOff className="size-8 text-[var(--color-danger)]" aria-hidden="true" />
        </span>
        <p className="mt-6 text-xs font-semibold uppercase tracking-widest text-[var(--color-danger)]">
          Access restricted
        </p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-[var(--color-heading)]">
          You do not have access to this page
        </h1>
        <p className="mt-2 text-sm text-[var(--color-muted)]">
          Your role does not include the permission this page needs. Ask your administrator if
          you need it.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-2">
          <Button variant="outline" onClick={() => void navigate(-1)}>
            <ArrowLeft className="rtl-flip" aria-hidden="true" /> Go back
          </Button>
          <Button asChild>
            <Link to="/"><LayoutDashboard aria-hidden="true" /> Back to dashboard</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
